export const TICKET_REQUEST = '@@ticket/TICKET_REQUEST';
export const TICKET_SUCCESS = '@@ticket/TICKET_SUCCESS';
export const TICKET_UPDATE = '@@ticket/TICKET_UPDATE';
export const TICKET_CLEAR = '@@ticket/TICKET_CLEAR';
export const TICKET_FAILURE = '@@ticket/TICKET_FAILURE';
export const PRODUCER_REQUEST = '@@producer/PRODUCER_REQUEST'
export const PRODUCER_SUCCESS = '@@producer/PRODUCER_SUCCESS'
export const PRODUCER_FAILURE = '@@producer/PRODUCER_FAILURE'
export const MODEL_REQUEST = '@@model/MODEL_REQUEST';
export const MODEL_SUCCESS = '@@model/MODEL_SUCCESS';
export const MODEL_UPDATE = '@@model/MODEL_UPDATE';
export const MODEL_FAILURE = '@@model/MODEL_FAILURE';
export const TYPE_REQUEST = '@@type/TYPE_REQUEST';
export const TYPE_SUCCESS = '@@type/TYPE_SUCCESS';
export const TYPE_UPDATE = '@@type/TYPE_UPDATE';
export const TYPE_FAILURE = '@@type/TYPE_FAILURE';
export const TICKETS_REQUEST = '@@tickets/TICKETS_REQUEST';
export const TICKETS_SUCCESS = '@@tickets/TICKETS_SUCCESS';
export const TICKETS_UPDATE = '@@tickets/TICKETS_UPDATE';
export const TICKETS_ADD = '@@tickets/TICKETS_ADD';
export const TICKETS_URL = '@@tickets/TICKETS_URL';
export const TICKETS_FAILURE = '@@tickets/TICKETS_FAILURE';
export const COMMENTADD_REQUEST = '@@commentadd/COMMENTADD_REQUEST';
export const COMMENTADD_SUCCESS = '@@commentadd/COMMENTADD_SUCCESS';
export const COMMENTADD_FAILURE = '@@commentadd/COMMENTADD_FAILURE';

export const COMMENTS_REQUEST = '@@comments/COMMENTS_REQUEST';
export const COMMENTS_SUCCESS = '@@comments/COMMENTS_SUCCESS';
export const COMMENTS_FAILURE = '@@comments/COMMENTS_FAILURE';
export const COMMENTS_CLEAR = '@@comments/COMMENTS_CLEAR';

export const TICKETSEND_REQUEST = '@@newticket/TICKETSEND_REQUEST';
export const TICKETSEND_SUCCESS = '@@newticket/TICKETSEND_SUCCESS';
export const TICKETSEND_FAILURE = '@@newticket/TICKETSEND_FAILURE';

export const REPORT_REQUEST = '@@report/REPORT_REQUEST';
export const REPORT_SUCCESS = '@@report/REPORT_SUCCESS';
export const REPORT_FAILURE = '@@report/REPORT_FAILURE';
export const REPORT_CLEAR = '@@report/REPORT_CLEAR';


export const REG_REQUEST = '@@region/REG_REQUEST';
export const REG_SUCCESS = '@@region/REG_SUCCESS';
export const REG_FAILURE = '@@region/REG_FAILURE';
export const REG_CLEAR = '@@region/REG_CLEAR';

export const LOGIN_REQUEST = '@@auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = '@@auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = '@@auth/LOGIN_FAILURE';
export const LOGOUT = '@@auth/LOGOUT';
export const TOKEN_REQUEST = '@@auth/TOKEN_REQUEST';
export const TOKEN_RECEIVED = '@@auth/TOKEN_RECEIVED';
export const TOKEN_FAILURE = '@@auth/TOKEN_FAILURE';
export const DEP_REQUEST = '@@dep/DEP_REQUEST';
export const DEP_SUCCESS = '@@dep/DEP_SUCCESS';
export const DEP_CLEAR = '@@dep/DEP_CLEAR';
export const DEP_FAILURE = '@@dep/DEP_FAILURE';
export const REPAIR_REQUEST = '@@repair/REPAIR_REQUEST';
export const REPAIR_SUCCESS = '@@repair/REPAIR_SUCCESS';
export const REPAIR_FAILURE = '@@repair/REPAIR_FAILURE';

export const REPAIRMODEL_REQUEST = '@@repairmodel/REPAIRMODEL_REQUEST';
export const REPAIRMODEL_SUCCESS = '@@repairmodel/REPAIRMODEL_SUCCESS';
export const REPAIRMODEL_FAILURE = '@@repairmodel/REPAIRMODEL_FAILURE';
export const REPAIRMODEL_CLEAR = '@@repairmodel/REPAIRMODEL_CLEAR';

export const STATUS_REQUEST = '@@status/STATUS_REQUEST';
export const STATUS_SUCCESS = '@@status/STATUS_SUCCESS';
export const STATUS_FAILURE = '@@status/STATUS_FAILURE';
export const UPDATE_TICKET_REQUEST = '@@update_ticket/UPDATE_TICKET_REQUEST'
export const UPDATE_TICKET_SUCCESS = '@@update_ticket/UPDATE_TICKET_SUCCESS'
export const UPDATE_TICKET_FAILED = '@@update_ticket/UPDATE_TICKET_FAILED'

export const HISTORY_REQUEST = '@@history/HISTORY_REQUEST'
export const HISTORY_SUCCESS = '@@history/HISTORY_SUCCESS'
export const HISTORY_FAILED = '@@history/HISTORY_FAILED'
export const HISTORY_CLEAR = '@@history/HISTORY_CLEAR'

export const LOAD_TICKETS = 'LOAD_TICKETS'
export const LOAD_TICKET = 'LOAD_TICKET'
export const FAIL_TICKET = 'FAIL_TICKET'
export const SUCCESS_TICKET = 'SUCCESS_TICKET'
export const CHANGE_SELECTION_RANGE = 'CHANGE_SELECTION_RANGE'
export const CHANGE_CODE = 'CHANGE_CODE'
export const START = '_START'
export const LOAD = '_LOAD'
export const SUCCESS = '_SUCCESS'
export const FAIL = '_FAIL'
export const UPDATE = '_UPDATE'

let API

if (process.env.NODE_ENV === 'production') {
     API = 'https://tracking.dpdok.com.ua/api'
} else {
     API = 'http://127.0.0.1:8000/api'
}

export const URL_API = API

export const LIMIT = 20
export const CHANGE_DATA_RANGE = 'CHANGE_DATA_RANGE'
export const CHANGE_SELECTION_STATUS = 'CHANGE_SELECTION_STATUS'
export const CHANGE_SELECTION_TECH = 'CHANGE_SELECTION_TECH'
export const CHANGE_SELECTION_MODEL = 'CHANGE_SELECTION_MODEL'
export const CHANGE_SELECTION_SERIAL = 'CHANGE_SELECTION_SERIAL'
export const CHANGE_SELECTION_PRODUCER = 'CHANGE_SELECTION_PRODUCER'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const TOGGLE_MODAL_COMMENT = 'TOGGLE_MODAL_COMMENT'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
////
export const MODEL_FILTER_REQUEST = '@@listmodel/MODEL_FILTER_REQUEST';
export const MODEL_FILTER_SUCCESS = '@@listmodel/MODEL_FILTER_SUCCESS';
export const MODEL_FILTER_CLEAR = '@@listmodel/MODEL_FILTER_CLEAR';
export const MODEL_FILTER_FAILURE = '@@listmodel/MODEL_FILTER_FAILURE';

export const MODEL_NEWTICKET_REQUEST = '@@listmodel/MODEL_NEWTICKET_REQUEST';
export const MODEL_NEWTICKET_SUCCESS = '@@listmodel/MODEL_NEWTICKET_SUCCESS';
export const MODEL_NEWTICKET_CLEAR = '@@listmodel/MODEL_NEWTICKET_CLEAR';
export const MODEL_NEWTICKET_FAILURE = '@@listmodel/MODEL_NEWTICKET_FAILURE';




// WEBPACK FOOTER //
// ./src/constants.js